export type SuggestedAmount = {
  profileId: number,
  suggestAmountId: number,
  languageCode: string,
  suggestedAmountType: string,
  lowerRangeAmount: number,
  upperRangeAmount: number,
  message: string,
  targetTypeCode: string,
  firstAmount: number,
  secondAmount: number,
  thirdAmount: number,
  showMessageOnly: boolean,
};

export type SuggestedAmountType = {
  name: string,
  value: string
}
export const suggestedAmountTypes: SuggestedAmountType[] = [
  { name: "dollar_amount", value: "Dollar" },
  { name: "percentage_increase", value: "Percentage" },

];
